import { chains } from '@emberswap/emberswap-sdk2/dist/constants'
import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { Chain } from 'viem'
import { Connector,useWalletClient } from 'wagmi'

export const useSwitchNetwork = async (
  chainid: ChainId,
  client: ReturnType<typeof useWalletClient>,
  connectors: Connector<any, any>[],
  connect: any
) => {
  /** `library` context here is invalid, we use the direct communcation with Metamask via window.ethereum */
  if (client.data) {
    try {
      await client.data.switchChain(chains[chainid]).catch((t) => console.log(t))
    } catch (switchError: any) {
      // These error codes indicates that the chain has not been added to MetaMask on mobile or desktop
      if (switchError.code === 4902 || switchError.code === -32603) {
        try {
          client.data.addChain({
            chain: chains[chainid] as Chain
          }
          )
        } catch (addError: any) {
          // handle adding network error
          throw addError
        } finally {
          const ready = connectors.filter((c) => connectors).some((c) => c.ready)
          if (ready) {
            connectors.forEach(() => {
              const connector = connectors.find((c) => c.ready)

              if (connector) {
                connector.isAuthorized().then((isAuth) => {
                  if (isAuth) {
                    connect({ connector })
                  }
                })
              }
            })
          }
        }
      } else {
        // handle other "switch" errors
        throw switchError
      }
    }
  }
}
